<template>
    <el-form :model="vo">
        <div>
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" class="el-table__body">
                    <tbody>
                        <tr>
                            <td v-field-lbl="'flSubject'" class="el-table__cell tdlbl tdw17" colspan="1">会议主题</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.flSubject }}</span>
                            </td>
                            <td v-field-lbl="'meetingName'" class="el-table__cell tdlbl tdw17" colspan="1">会议室名称</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.meetPlace }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td v-field-lbl="'startTime'" class="el-table__cell tdlbl tdw17" colspan="1">开始时间</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.startTime }}</span>
                            </td>
                            <td v-field-lbl="'endTime'" class="el-table__cell tdlbl tdw17" colspan="1">结束时间</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.endTime }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td v-field-lbl="'flCreator'" class="el-table__cell tdlbl tdw17" colspan="1">召集人</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.flCreator }}</span>
                            </td>
                            <td v-field-lbl="'flCreateDept'" class="el-table__cell tdlbl tdw17" colspan="1">召集部门</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.flCreateDept }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td v-field-lbl="'summaryPhone'" class="el-table__cell tdlbl tdw17" colspan="1">联系电话</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.flCreatorPhone }}</span>
                            </td>
                            <td v-field-lbl="'meetHost'" class="el-table__cell tdlbl tdw17" colspan="1">会议主持人</td>
                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                <span>{{ vo.meetHost }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td v-field-lbl="'attendLeader'" class="el-table__cell tdlbl tdw17" colspan="1">出席领导</td>
                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                <span>{{ vo.attendLeader }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td ref="tdlbl_会议主题" v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17" colspan="1">会议内容</td>
                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                <span>{{ vo.flContent }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_会议主题" v-field-lbl="'meetingAttach'" class="el-table__cell tdlbl tdw17" colspan="1">会议附件</td>
                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                <div v-for="item in attachs" :key="item">
                                    <span class="hoverSpan" style="cursor: pointer; color: #409efe" @click="downloadFuc(item.id)">{{ item.fileName }}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </el-form>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            attachs: null
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$http({
            method: 'GET',
            contentType: 'application/x-www-form-urlencoded',
            params: {
                busiDataIds: this.vo.id
            },
            url: '/hygl/attach/queryAttachList'
        }).then((result) => {
            if (result.code === 'success') {
                this.attachs = result.body.listdata
            } else {
                this.$message.error(result.message)
            }
        })
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        downloadFuc(id, num) {
            var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            window.open(attachurl, '_blank')
        }
    }
}
</script>

<style scoped lang="scss">
</style>
